import { render, staticRenderFns } from "./meals.vue?vue&type=template&id=4d2b5fcc&scoped=true&"
import script from "./meals.vue?vue&type=script&lang=js&"
export * from "./meals.vue?vue&type=script&lang=js&"
import style0 from "./meals.vue?vue&type=style&index=0&id=4d2b5fcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2b5fcc",
  null
  
)

export default component.exports